export class MapTagsLoadGroups {
  static readonly type = '[MatTags] Load Groups';
}

export class MapTagsLoadTags {
  static readonly type = '[MatTags] Load Tags';
}

export class MapTagsDeleteTags {
  static readonly type = '[MatTags] Delete Tags';
}

export class MapTagsDeleteGroups {
  static readonly type = '[MatTags] Delete Groups';
}

export class MapTagsLoadPositions {
  static readonly type = '[MatTags] Load Position';
}

export class MapTagsDeletePositions {
  static readonly type = '[MatTags] Delete Position';
}

export class MapTagsLoadGroupsAndResources {
  static readonly type = '[MapSites] Load Groups and Resources';
}

export class MapTagsLoadDataModel {
  static readonly type = '[MapTag] Load Data Model';
}

export class MapTagsDeleteDataModel {
  static readonly type = '[MapTag] Delete Data Model';
}

export class MapTagsClearAll {
  static readonly type = '[MapTag] Clear All';
}
